import type { API } from 'chessboard/api/config/types';
import { Core } from 'chessboard/core/config/types';

/**
 * Create the createContinuation method.
 */
export function createCreateContinuation(context: API.Context) {
  /**
   * Call the JCE createVariation method and make a move to make a continuation.
   */
  return function createContinuation(): API.Response {
    const { api, game, respond } = context;

    const currentNode = game._getPos(); // eslint-disable-line no-underscore-dangle

    // If the currentNode is the starting position (not a JCE.Move.Node) we can't make
    // a move
    if ('initial' in currentNode) {
      return null;
    }

    game.createVariation();
    game.move(currentNode);

    const node = api.getRelativeNode();

    return respond(Core.APIEvents.CreateContinuation, {
      node,
    });
  };
}
